import React, {FC} from 'react';
import classNames from 'classnames';
import {getFirstLetterOfNames, ThumbnailColors} from 'utils';

interface AvatarProps {
  image?: string;
  online?: boolean;
  fullName: string;
  classes?: string;
  noOnlineStatus?: boolean;
}
export const Avatar: FC<AvatarProps> = ({
  image,
  fullName = '',
  online,
  classes = '',
  noOnlineStatus = false,
}) => {
  const firstLetterOfName = getFirstLetterOfNames(fullName);
  const firstLetter = firstLetterOfName
    .charAt(0)
    .toLowerCase() as keyof typeof ThumbnailColors;
  const colors = ThumbnailColors[firstLetter];

  return (
    <section
      className={classNames(
        `relative flex items-center justify-center rounded-full text-base bg-opacity-10 uppercase aspect-square ${classes}`,
        {
          'w-8 h-8': noOnlineStatus,
          'w-10 h-10': !noOnlineStatus,
        },
      )}
      style={{background: colors.bg, color: colors.text}}
    >
      {image ? (
        <img
          src={image}
          className="rounded-full w-full h-full object-cover aspect-square"
          alt={fullName}
        />
      ) : (
        <span
          className={classNames({
            'text-sm': noOnlineStatus,
          })}
        >
          {fullName ? firstLetterOfName : null}
        </span>
      )}
      {noOnlineStatus || !online ? null : (
        <div
          className={`absolute right-0 bottom-0 h-3 w-3 rounded-full border-2 border-white ${
            online ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
      )}
    </section>
  );
};
